import { API_URL } from '../../infra/environment'
import { HttpClient } from '../../infra/http/HttpClient'
import { ShipmentTagRepository } from '../infra/ShipmentTagRepository'

type GetCarrierShipmentTagsDependencies = {
  repository: ShipmentTagRepository
}

export function getCarrierShipmentTagsFactory({ repository }: GetCarrierShipmentTagsDependencies) {
  return function getTagsImpl(config?: { signal?: AbortSignal }) {
    return repository.fetchCarrierShipmentTags(config)
  }
}

export function getCarrierShipmentTags(config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)

  const repository = new ShipmentTagRepository({ httpClient })
  const get = getCarrierShipmentTagsFactory({ repository })

  return get(config)
}
